import { useEnvironmentVariables } from 'app-kit'

/**
 * If the user can visit the site view.
 *
 * This function checks if the current environment is not a government environment (to exclude Gov users),
 * and that it is not running in SecondFront (to exclude UAE users).
 */
export function useCanVisitSiteView(): boolean {
  // Gov users and ADNOC users do not have access to Site View
  const { IS_MULTI_TENANT_ENVIRONMENT } = useEnvironmentVariables()
  return IS_MULTI_TENANT_ENVIRONMENT
}
